define("shared/utils/analytics/timezone-helpers/compute-utc-offset-from-tz", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  /**
   * @module Utils
   */

  /**
   * @class computeUtcOffsetFromTz
   * @extends Utils
   */

  /**
   * Computes offset in hours from UTC timezone
   *
   * @method computeUtcOffsetFromTz
   * @param {String} timeZoneIdentifier
   *
   * @return {Number} Number of hours offset from UTC timezone to timezone given.
   */
  const computeUtcOffsetFromTz = timeZoneIdentifier => {
    const oneHourInMinutes = 60;
    return moment().tz(timeZoneIdentifier).utcOffset() / oneHourInMinutes;
  };

  var _default = computeUtcOffsetFromTz;
  _exports.default = _default;
});